import { Add } from "@mui/icons-material";
import { Box, Button, Container, Tab } from "@mui/material";
import React, { useState } from "react";
import PendingTerminal from "./PendingTerminal";
import ViewTerminal from "./ViewTerminal";
import HistoryTerminal from "./HistoryTerminal";
import HeaderHelpPage from "../HeaderHelpPage";
import { writeLog } from "../../services/services";
import { TabPanel } from "@mui/lab";
import TabsMenu from "../TabsMenu";
import CreateNewTerminal from "../../pages/Admin/CreateNewTerminal";
import { styles } from "../../utils/styles";

const TerminalSwitchView = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const [createDialog, setCreateDialog] = useState(false);

  const handleChange = (event, value) => {
    setSelectedView(value);
  };
  return (
    <Container>
      <HeaderHelpPage title="Terminal" description="This page manage Terminal List on our system." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="Pending" value="Pending" />
        <Tab label="History" value="History" />
        {(
          localStorage.getItem("role") === "admin" ||
          (userRole.includes("Add") && selectedView === "All")
        ) && (
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                writeLog('[Info] - Click button [Add New Terminal] - Open new tab to Create A New Terminal')
                setCreateDialog(true);
              }}
              startIcon={<Add />}
              sx={{ ...styles.customButton }}
            >
              Add New Terminal
          </Button>
          </Box>
        )}
        
        <TabPanel value="All">
          <ViewTerminal userRole={userRole} />
        </TabPanel>
        <TabPanel value="Pending">
          <PendingTerminal userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <HistoryTerminal userRole={userRole} />
        </TabPanel>
      </TabsMenu>

      {createDialog && <CreateNewTerminal open={true} onClose={() => setCreateDialog(false)} />}
    </Container>
  );
};

export default TerminalSwitchView;
